import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../common/LoadingSpinner";
import GameRelatedListContainer from "./GameRelatedListContainer";
import { TermType, useGetTerm } from "../../utils/useTerm";
import { SonicTermData } from "../../common/classes/SonicTerm";

const GameRelatedListTermContainer: React.FC = () => {
  const [searchWord, setSearchWord] = useState<string>();

  const handleSearchOption = (keyword: string) => {
    setSearchWord(keyword ? keyword : undefined);
  };

  const {
    termData: { entries },
    getTermLoading,
  } = useGetTerm(TermType.Games, undefined, -1, searchWord);

  const [defaultOptions, setDefaultOptions] = useState<Array<SonicTermData>>();

  useEffect(() => {
    if (defaultOptions !== undefined) return;

    if (entries.length > 0) {
      setDefaultOptions(entries);
    }
  }, [entries]);

  if (!defaultOptions) {
    return <LoadingSpinner space={1} />;
  }

  return (
    <GameRelatedListContainer
      modalLoading={getTermLoading}
      defaultOptions={defaultOptions}
      modalOptions={entries}
      handleSearchOption={handleSearchOption}
    />
  );
};

export default GameRelatedListTermContainer;
